/* src/app/module/service-provider/add-sp-new-component/service-offered/add-service-modal/add-service-modal.component.scss */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  width: 400px;
}
.modal-content h4 {
  margin-bottom: 20px;
}
.modal-content p {
  margin-bottom: 10px;
}
.modal-content ul {
  text-align: left;
  margin-bottom: 20px;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
}
.modal-footer .cancel-button {
  background-color: #FFFFFF;
  color: #344054;
  border: 1px solid #D0D5DD;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
.modal-footer .approve-button {
  background-color: #FF8C00;
  color: #FFFFFF;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
/*# sourceMappingURL=add-service-modal.component-FPNLQ4RG.css.map */
